import type { SVGProps } from "react";
import * as React from "react";
const SvgCustomerService = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 17.002a6.002 6.002 0 0 1-4.713 5.86l-.638-1.914A4.003 4.003 0 0 0 19.465 19H18a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h1.938a8.001 8.001 0 0 0-15.876 0H6a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H4a2 2 0 0 1-2-2v-5C2 6.477 6.477 2 12 2s10 4.477 10 10v5.002ZM20 17v-4h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2ZM4 13v4h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H4Z"
    />
  </svg>
);
export default SvgCustomerService;
